import {
  isContainerTargetType,
  isHostTargetType
} from 'components/attacks/utils/attack-configuration'
import { type TargetingStrategy } from 'types/api/attacks/details/targeting'

export function getTargetMultiValueMap(targetingStrategy: TargetingStrategy) {
  if (isHostTargetType(targetingStrategy)) {
    return targetingStrategy.tags ?? targetingStrategy.multiSelectTags
  }

  if (isContainerTargetType(targetingStrategy)) {
    return targetingStrategy.labels ?? targetingStrategy.multiSelectLabels
  }

  return targetingStrategy.names?.reduce(
    (objects: Record<string, string[]>, target) => {
      if (!Array.isArray(objects[target?.kind])) {
        objects[target.kind] = []
      }
      objects[target.kind]?.push(target.name)
      return objects
    },
    {}
  )
}
